<script setup lang="ts">
import { Badge } from "~/components/clarity-ui/Badge";
import useMarketSetup from "~/composables/useMarketSetup";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

export interface CartButtonProps {
  /** A string representing the ARIA label for the element. */
  ariaLabel?: string;
}

const { ariaLabel } = defineProps<CartButtonProps>();

const { marketSetupAdmin } = useMarketSetup();
const { count } = useCartInformation();

const emit = defineEmits(["cartCountChange"]);

const onCartCountChange = inject<() => void>("onCartCountChange");

watch(count, () => {
  emit("cartCountChange");

  if (onCartCountChange) {
    onCartCountChange();
  }
});
</script>

<template>
  <NuxtLink
    class="relative h-11 w-11 rounded-md p-2 hover:text-deep-blue"
    :aria-label="ariaLabel"
    :to="marketSetupAdmin?.cartPage ?? ''"
    :external="true"
    data-testid="cart-button"
  >
    <SvgIcon class="absolute left-[calc(50%-12px)] top-[calc(50%-12px)] h-6 w-6" name="Cart" />
    <Badge v-if="count > 0" class="absolute bottom-1 right-0" is-dynamic data-testid="cart-count">{{
      count
    }}</Badge>
  </NuxtLink>
</template>
